// extracted by mini-css-extract-plugin
export default {"button":"LocalSwitcher_button_ZqDJh"};